import { and, asc, desc, eq } from "drizzle-orm";
import {
  ingredient,
  type PowerSyncDrizzleDB,
  recipe_item,
  stock_movement,
} from "@comandero/powersync";
import {
  liveIngredientFilters,
  liveRecipeItemFilters,
  liveStockMovementFilters,
} from "../live/filters";

/** Org ingredients (with stock), sorted by name.*/
export function getIngredientsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(ingredient)
    .where(and(eq(ingredient.organization_id, organizationId), ...liveIngredientFilters()))
    .orderBy(asc(ingredient.name));
}

/** BOM of a product: ingredients it consumes and in what quantity.*/
export function getRecipeItemsQuery(db: PowerSyncDrizzleDB, productId: string) {
  return db
    .select()
    .from(recipe_item)
    .where(and(eq(recipe_item.product_id, productId), ...liveRecipeItemFilters()));
}

/** All org recipes (to resolve order consumption).*/
export function getAllRecipeItemsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(recipe_item)
    .where(and(eq(recipe_item.organization_id, organizationId), ...liveRecipeItemFilters()));
}

/** Stock movements of an ingredient (audit of derived balance).*/
export function getStockMovementsQuery(db: PowerSyncDrizzleDB, ingredientId: string) {
  return db
    .select()
    .from(stock_movement)
    .where(and(eq(stock_movement.ingredient_id, ingredientId), ...liveStockMovementFilters()))
    .orderBy(desc(stock_movement.created_at));
}
